import stripePaymentIntent from "./stripePaymentIntent.js";

// Alpine's x-model owns the radio state, so the `days` option decides which
// duration loads selected. Keep it and the Elements amount on one value:
// Stripe shows it in the Apple Pay and Link sheets before any change fires.
export default ({ amounts, prices, days, ...options }) => {
  const base = stripePaymentIntent({ ...options, amount: amounts[days] });

  return {
    ...base,
    days,

    prices,

    get body() {
      return { days: this.days };
    },

    setAmount(amount) {
      this.amount = amount;
      this.elements?.update({ amount });
    },

    async init() {
      this.$watch("days", () => {
        this.setAmount(amounts[this.days]);

        this.$dispatch("upgrade-days", {
          label: `Promote for ${this.days} days · ${prices[this.days]}`,
        });
      });

      await base.init.call(this);
    },
  };
};
